
import XLSX from 'xlsx'

export default {
    load(file){
        return new Promise((resolve, reject)=>{
            var reader = new FileReader();
            reader.onload = function(e) {
                var data = e.target.result;
                var workbook = XLSX.read(data, {type: 'binary'});
                var csv = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])
                resolve(csv);
            };
            reader.onerror = reject;
            reader.readAsBinaryString(file);
        });
        
    }
}